module.exports = __webpack_public_path__ + "static/media/content.8dcc5dc4.md";